export default __webpack_public_path__ + "static/park2015-3413f97b10b6f3f7a5098b18d0a50c2e.png";